<template>
    <div class="row">
        <div class="col-sm-12 col-lg-2">
            <product-selector @load-products="getProducts"></product-selector>
        </div>
        <div class="col-sm">
            <product-list :products="products"></product-list>
        </div>
    </div>
</template>

<script>
import ProductList from './ProductList.vue'
export default {
    data() {
        return {
        }
    },
    props: {
        products: Array
    },
    methods: {
        getProducts: function(obj) {
            //Get data from api endpoint
            console.log(obj);
            var req_params = '?';

            for(var index in obj) {
                if (obj.hasOwnProperty(index)) {
                    req_params+= index + '=' + obj[index] + '&';
                }
            }
            axios.get('/api/products' + req_params,
            ).then(response => {
                this.products = JSON.parse(response.data.data);
                console.log(this.products);
            }).catch(error => {
                console.log(error.response.data);
            });
        }
    },
    mounted() {
    },
    components: {
    }
}
</script>
